import styled from "styled-components";
import { useState } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 35px;

  font-family: "Noto Sans KR";
  font-size: 15px;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  padding-right: 30px;

  border: none;
  border-radius: 4px;
  background: #eeeeee;
  
  font: inherit;
  color: #363636;

  &::placeholder {
    color: black;
  }

  &:focus {
    color: black;
  }
`;

const ShowButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;

  height: 100%;
  aspect-ratio: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  svg {
    width: 60%;
    height: 60%;
  }
`;

export const PasswordInput = ({ className,  ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <Wrapper className={className}>
      <Input {...props} type={visible ? 'text' : 'password'} />
      <ShowButton
        type="button"
        onClick={() => setVisible(prev => !prev)}
        aria-label={visible ? '비밀번호 숨기기' : '비밀번호 보기'}
      >
        {visible ? <LuEyeOff /> : <LuEye />}
      </ShowButton>
    </Wrapper>
  );
};